import { useContext } from 'react';
import { ThemeColors } from '../context/ThemeColors';

export const useThemeColors = () => {
	const { colors } = useContext(ThemeColors);
	return colors;
};
